export default __webpack_public_path__ + "203092056df6c37fd2eaf31e573f767c.png";